<template>
  <div class="menu">
    <div @click="exportChords">Export</div>
    <div>Transpose</div>
    <div>Measures + -</div>
    <div>Time Signature</div>
  </div>
  <div id="chord-typer">
    <ChordTable ref="ChordTable" :chord-candidates="holdChords" :config="chordTableConfig"/>
    <CurrentChords :chords="holdChords.map(c => {return {...c, uuid: v4()}})" @input_chord="inputChord"
                   @update_config="updateConfig"/>
  </div>
  <SettingsPanel/>
</template>

<script>
import ChordTable from '@/components/ChordTable'
import SettingsPanel from '@/components/SettingsPanel'
import CurrentChords from '@/components/CurrentChords'
import { MIDIAgent } from '@/utils/MIDIAgent.js'
import { lookupChords } from '@/utils/Chord'
import { v4 } from 'uuid'

export default {
  name: 'ChordTyper',
  components: {
    ChordTable,
    SettingsPanel,
    CurrentChords
  },
  setup () {
    return {
      lookupChords: lookupChords,
      v4: v4
    }
  },
  data () {
    return {
      pressedNotes: new Set(),
      sustainedNotes: new Set(),
      allNotes: new Set(),
      holdNotes: new Set(),
      sustainDown: false,
      releaseFlag: false,
      previousDeltaNotes: 0,
      config: {
        useBass: true,
        inputAfterRelease: true,
        pitchSplittingPoint: 54
      }
    }
  },
  beforeCreate () {
    this.$MIDIAgent = new MIDIAgent(['5- Yamaha MX Series-1'])
    window.$MIDIAgent = this.$MIDIAgent
  },
  created () {
    window.addEventListener('notes_update', this.onNotesUpdate)
  },
  computed: {
    holdChords () {
      return lookupChords(this.holdNotes)
    },
    chordTableConfig () {
      return this.config
    }
  },
  methods: {
    updateSet (dest, src) {
      for (const x of src) {
        if (!dest.has(x)) {
          dest.add(x)
        }
      }
      for (const x of dest) {
        if (!src.has(x)) {
          dest.delete(x)
        }
      }
    },
    updateConfig (e) {
      for (const x in e) {
        this.config[x] = e[x]
      }
    },
    updateSetWithStat (dest, src) {
      let deltaNotes = 0
      for (const x of src) {
        if (!dest.has(x)) {
          dest.add(x)
          deltaNotes++
        }
      }
      for (const x of dest) {
        if (!src.has(x)) {
          dest.delete(x)
          deltaNotes--
        }
      }
      // console.log(`delta = ${deltaNotes}`)

      // Update hold notes only when new notes appear
      if (deltaNotes > 0) {
        if (this.allNotes.size > 1) {
          this.holdNotes = new Set(this.allNotes)
        }
      } else if (this.allNotes.size === 0 && this.previousDeltaNotes < 0) {
        // Mark release if at least 2 keys are released
        this.releaseFlag = true
      }
      this.previousDeltaNotes = deltaNotes
    },
    onNotesUpdate ({ detail }) {
      this.pressedNotes = new Set(detail.pressedNotes)
      this.sustainedNotes = new Set(detail.sustainedNotes)
      this.updateSetWithStat(this.allNotes, detail.allNotes)
      this.sustainDown = detail.sustainDown
      if (this.config.inputAfterRelease && this.holdChords.length > 0 && this.allNotes.size === 0 && this.releaseFlag) {
        if (typeof (this.$refs.ChordTable) !== 'undefined') {
          // console.log('triggered')
          this.$refs.ChordTable.inputChordTriggeredByKeyboard(this.holdNotes)
        }
        this.releaseFlag = false
      }
    },
    inputChord (eventFromCurrentChords) {
      if (!!this.$refs.ChordTable) {
        this.$refs.ChordTable.inputChord(eventFromCurrentChords)
      }
    },
    exportChords () {
      if (!!this.$refs.ChordTable) {
        this.$refs.ChordTable.exportChords()
      }
    }
  }
}
</script>

<style>
#chord-typer {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  margin: 5px;
}

body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  height: 100%;
  /*overflow: hidden;*/
  padding: 5px;
}

header {
  height: 30px;
  min-height: 30px;
  display: flex;
  justify-content: left;
  align-items: center;
  background: #ddd;
  position: relative;
  padding: 3px;
  border-radius: 3px;
}

.menu {
  display: flex;
  justify-content: start;
  padding: 5px;
}

.menu div {
  padding: 5px;
  margin-right: 5px;
  border-radius: 3px;
  background: #eee;
  user-select: none;
}

.menu div:hover {
  background: #ddd;
  cursor: pointer;
}

</style>
